<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">{{
          $t("structure.title")
        }}</span>
        <h3 class="page-title">{{ $t("structure.subtitle") }}</h3>
      </div>
    </div>

    <d-row>
      <d-col lg="12" class="mb-4">
        <d-button class="btn-primary" @click="addStructure"
          ><i class="fa fa-plus mr-2"></i>
          {{ $t("structure.add.button") }}</d-button
        >
      </d-col>
    </d-row>
    <add-edit-structure
      ref="modalStructure"
      @updateStructure="load"
    ></add-edit-structure>
    <d-row>
      <d-col v-for="(structure, idx) in structuresList" :key="idx" lg="4">
        <d-card class="card-small card-post mb-4">
          <d-card-body>
            <h5 class="card-title">
              {{ structure.name }}
              <span @click="deleteStructure(structure)" class="delete-icon"
                ><i class="fa fa-trash icon-rond"></i
              ></span>
            </h5>
            <p class="card-text text-muted">
              {{ structure.address }}<br />
              {{ structure.zipCode }} {{ structure.city }}
            </p>
          </d-card-body>
          <d-card-footer class="border-top d-flex p-3">
            <div class="card-post__author d-flex">
              <a
                href="#"
                class="card-post__author-avatar card-post__author-avatar--small"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/images/users/user.jpg') + ')',
                }"
              ></a>
              <div class="d-flex flex-column justify-content-center ml-3">
                <a href="#" @click.prevent="listAffiliate(structure.reference)"
                  ><a class="card-post__author-name"
                    >{{ structure._totalAffiliate }}
                    {{ $t("structure.list.affiliate") }}</a
                  ></a
                >
                <small class="text-muted"
                  >{{ $t("structure.list.createdAt") }}
                  {{ formatDate(structure.creationDate) }}</small
                >
              </div>
            </div>
            <div class="my-auto ml-auto">
              <d-button
                size="sm"
                class="btn-white"
                @click="editStructure(structure)"
              >
                <i class="fa fa-edit mr-1"></i>
                {{ $t("structure.list.edit.button") }}
              </d-button>
            </div>
          </d-card-footer>
        </d-card>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import AddEditStructure from '../../components/structure/AddEditStructure.vue';
import TimeUtils from '../../utils/TimeUtils';

export default {
  name: 'Structures',
  components: { AddEditStructure },
  beforeRouteEnter(to, from, next){
    next(vm=>vm.load())
  },
  data() {
    return {
      model: null,
    };
  },
  computed: {
    structuresList() {
      return this.$store.state.structure.list;
    },
  },
  methods: {
    listAffiliate(reference) {
      const listForm = { structureReference: reference };
      this.$store.commit('setListUserModel', listForm);
      this.$router.push('/liste-utilisateurs');
    },
    formatDate(date) {
      return TimeUtils.formatDate(date);
    },
    addStructure() {
      this.$refs.modalStructure.openModal();
    },
    editStructure(structure) {
      this.$refs.modalStructure.openModal(structure);
    },
    deleteStructure(structure) {
      this.$confirmModal.show({
        text: 'Voulez-vous vraiment supprimer cette structure ?',
        onConfirm: () => {
          if (structure._totalAffiliate > 0) {
            this.$miniToastr.error(`Il reste ${structure._totalAffiliate} employé(s) à réattribuer dans une autre structure pour pouvoir supprimer celle-ci.`);
          } else {
            this.$services.structure.delete(structure).then(() => {
              this.load();
              this.$miniToastr.success('La structure a bien été supprimée.');
            });
          }
        },
      });
    },
    load() {
      this.$services.structure.findAll({}).then(({ data }) => {
        this.$store.commit('updateStructuresList', data);
      });
    },
  },
};
</script>

<style scoped>
.card-post__author-avatar--small {
  width: 1.8875rem !important;
  height: 1.8875rem !important;
}
.delete-icon {
  float: right;
  font-size: 16px;
  cursor: pointer;
  color: #a8b5ce;
}
</style>
